export const COUNTRIES_WITHOUT_DISCOUNT_OFFER = ['PH', 'ZA', 'TW'];
